import { useConfigContext } from '@omq/shared';

import { Navigation, type NavigationItemType } from './navigation';
import type { HelpCategory } from '../../api/help';

/**
 * Type for component properties.
 */
type QuestionNavigationProps = {
  title: string;
  onRootClick: (item: null) => void;
  onCategorySelection: (url: string | null) => void;
  categories?: Array<HelpCategory>;
};

// map categories to navigation items
function mapNavigationItems(items: Array<HelpCategory>): Array<NavigationItemType> {
  if (!items) {
    return [];
  }
  return items.map((item) => {
    return {
      id: item.id,
      name: item.name,
      href : item.url,
    };
  });
}

/**
 * Render navigation with root item and a single question.
 *
 * @param {QuestionNavigationProps} props - Component properties
 *
 * @author Florian Walch
 * @since 9.3
 *
 * @returns {JSX.Element}
 */
export function QuestionNavigation(props: QuestionNavigationProps): JSX.Element {
  const { title, onRootClick, categories, onCategorySelection } = props;
  const config = useConfigContext();

  // build navigation items
  const items = [
    {
      id: 0,
      href: '/',
      name: config.loc('navigation_root'),
    },
    ...mapNavigationItems(categories),
    {
      id: 1,
      href: null,
      name: title,
    },
  ];

  // handle item click
  // if root item clicked, call onRootClick
  // otherwise call onCategorySelection
  const onItemClick = (item) => {
    if (item.id === 0){
      onRootClick(null);
    } else {
      onCategorySelection(item.href)
    }

  };

  return <Navigation items={items} onItemClick={onItemClick} styleName="question-navigation" />;
}
